import { EditorColoringType } from '../interfaces/editorSettings';
/**
 * The display configuration an inspection area falls back to when it has none saved.
 *
 * Shared because both 3D hosts need the same fallback: the Editor seeds its settings store from
 * it, and the Platform's 3D view seeds its live display state from it.
 */
export const DefaultEditorDisplayConfig = {
    general: {
        bg_color: '#000000',
        label_size: 1,
        display_type: EditorColoringType.Auto,
        unlabeled_color: '#FFFFFF',
    },
    pcd: {
        visible: true,
        opacity: 1,
        point_size: 1,
    },
    mesh: {
        visible: true,
        opacity: 1,
    },
    polyline: {
        color: '#000000',
        primary: {
            label: {
                visible: true,
                text_color: '#000000',
                bg_color: '#88DF41',
            },
        },
        edge: {
            label: {
                visible: false,
                text_color: '#000000',
                bg_color: '#88DF41',
            },
        },
    },
    plane: {
        color: '#90ee90',
        opacity: 1,
        primary: {
            label: {
                visible: true,
                text_color: '#000000',
                bg_color: '#FFFF00',
            },
        },
        edge: {
            label: {
                visible: true,
                text_color: '#000000',
                bg_color: '#FFFFFF',
            },
        },
    },
    volume: {
        upper: {
            color: '#33a3ff',
            opacity: 0.7,
            edge: {
                label: {
                    visible: true,
                    text_color: '#FFFFFF',
                    bg_color: '#42a8fb',
                },
            },
            primary: {
                label: {
                    visible: true,
                    text_color: '#000000',
                    bg_color: '#FFFF00',
                },
            },
        },
        lower: {
            color: '#dd6b20',
            opacity: 0.7,
            edge: {
                label: {
                    visible: true,
                    text_color: '#FFFFFF',
                    bg_color: '#df8244',
                },
            },
            primary: {
                label: {
                    visible: true,
                    text_color: '#000000',
                    bg_color: '#FFFF00',
                },
            },
        },
    },
    depth: {
        upper: {
            label: {
                visible: true,
                text_color: '#FFFFFF',
                bg_color: '#ff0000',
            },
            show: {
                min: true,
                max: true,
                avg: true,
            },
        },
        lower: {
            label: {
                visible: true,
                text_color: '#FFFFFF',
                bg_color: '#FFA500',
            },
            show: {
                min: true,
                max: true,
                avg: true,
            },
        },
    },
    grid: {
        label: {
            visible: true,
            text_color: '#000000',
            bg_color: '#88DF41',
        },
        error: {
            label: {
                visible: true,
                text_color: '#000000',
                bg_color: '#FFFF00',
            },
        },
    },
    rebar: {
        color: '#ff0000',
        primary: {
            label: {
                visible: true,
                text_color: '#000000',
                bg_color: '#FFFF00',
            },
        },
    },
    custom_measurement: {
        color: '#000000',
        primary: {
            label: {
                visible: true,
                text_color: '#000000',
                bg_color: '#88DF41',
            },
        },
    },
};
